import { packageConstants } from '../constants';
import { packageService } from '../../services';

export const packageActions = {
  packagesList,
  addPackage,
  getPackage,
  updatePackage
}

/*
ACTION: Packages List
*/
function packagesList(addToast, pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return packageService.packagesList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.packaging, response.data.body.data.total));
        },
        error => {
          if (typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: packageConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: packageConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: packageConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Package
*/
function addPackage(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return packageService.addPackage(formData)
      .then(
        response => {
          addToast('بسته با موفقیت افزوده شد', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if (typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: packageConstants.ADD_REQUEST } }
  function success(status) { return { type: packageConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: packageConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Package By ID
*/
function getPackage(addToast, packageID) {
  return dispatch => {
    dispatch(request());
    return packageService.getPackage(packageID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if (typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: packageConstants.GET_REQUEST } }
  function success(item) { return { type: packageConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: packageConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Package
*/
function updatePackage(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return packageService.updatePackage(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if (typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: packageConstants.UPDATE_REQUEST } }
  function success(status) { return { type: packageConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: packageConstants.UPDATE_FAILURE, error } }
}